import { useEffect, useState } from "react";
import { useGuider } from "./guider";

export const useReferences = () => {
  const [guiderMenuItem, setGuiderMenuItem] = useState<string>();
  const { guider } = useGuider(undefined);

  const menuItems = [
    { label: "Home", link: "/" },
    { label: "About", link: "/about" },
    { label: "Portfolio", link: "/portfolio" },
  ];

  useEffect(() => {
    menuItems.forEach((item, index) => {
      if (guider && item.link === guider.step.stepUrl) {
        setGuiderMenuItem(
          index + 1 === menuItems.length ? "" : menuItems[index + 1].label
        );
      }
    });
  }, [guider]);

  return { menuItems, guiderMenuItem };
};
